import { configureStore } from "@reduxjs/toolkit";
import postsReducer from "../features/posts/postsSlice";
import postReducer from "../features/post/postSlice";
import relatedPostsReducer from "../features/relatedPosts/relatedPostsSlice";
import likeSReducer from "../features/like/likeSlice";
import savedReducer from "../features/saved/savedSlice";


export const store = configureStore({
  reducer: {
    posts: postsReducer,
    post: postReducer,
    relatedPosts: relatedPostsReducer,
    likes: likeSReducer,
    isSaved: savedReducer,
   
  },
});
